TrelloModel = require 'models/internal/trello-model'

module.exports = class Sticker extends TrelloModel
  typeName: 'Sticker'



// WEBPACK FOOTER //
// ./app/scripts/models/sticker.coffee